import { render, staticRenderFns } from "./PressureDetection.vue?vue&type=template&id=2e92e110&scoped=true"
import script from "./PressureDetection.vue?vue&type=script&lang=js"
export * from "./PressureDetection.vue?vue&type=script&lang=js"
import style0 from "./PressureDetection.vue?vue&type=style&index=0&id=2e92e110&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e92e110",
  null
  
)

export default component.exports